import React from 'react';
import Picture from '../../../@shared/picture';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';

function PrintTable({ colHeadings, mrpRow, categoryRows }) {
  const { sitecoreContext } = useSitecoreContext();
  const brandLogoImageData = sitecoreContext?.defaultBackgroundImageParametersV2;
  return (
    <div className="model-detail-specification-table-print-wrapper">
      <div className="model-detail-specification-table-print model-detail-specification-table-print__grid">
      { !!brandLogoImageData  && ( 
          <div className="model-detail-specification-table-print__image">
            <Picture
              editorialImageProps={{
                desktopImage: brandLogoImageData?.desktopImageData?.logoImage,
                mobileImage: brandLogoImageData?.mobileImageData?.logoImage,
                desktopTransformation: 'Size200',
                mobileTransformation: 'Size200',
                cssClassImageEl: 'print-navigation-logo-image',
                prioritize: true,
              }}
            />
          </div>
        )}
        <div className="model-detail-specification-table-print__col-heading"></div>
        {colHeadings?.map((val) => (
          <div className="model-detail-specification-table-print__col-heading">{val}</div>
        ))}
        {mrpRow.label && (
          <div
            className={`
              model-detail-specification-table-print__left-side-accordion-spec-title
              model-detail-specification-table-print__left-most-cell
              model-detail-specification-table-print__spec-row-child
            `}
          >
            <div className="model-detail-specification-table-print__left-side-accordion-spec-title__inner-box model-detail-specification-table-print__left-side-accordion-spec-title__inner-box--last-row">
              <div>{mrpRow.label}</div>
            </div>
          </div>
        )}
        {mrpRow.prices.map((spec, specIndex) => (
          <div
            key={`model-detail-specification-table-print__spec-${spec}`}
            className={`
                    model-detail-specification-table-print__spec
                    model-detail-specification-table-print__spec--${specIndex % 2 === 0 ? 'even' : 'odd'}
                    model-detail-specification-table-print__spec--last-row
                  `}
          >
            {spec}
          </div>
        ))}
        {categoryRows.map((obj) => (
          <>
            <div className="model-detail-specification-table-print__spec-category-row">
              <div className="model-detail-specification-table-print__left-most-cell model-detail-specification-table-print__spec-category-row__inner-box-wrapper">
                <div className="model-detail-specification-table-print__spec-category-row__inner-box">{obj.group}</div>
              </div>
              <div className="model-detail-specification-table-print__spec-category-row__empty-row"></div>
            </div>
            {obj.items &&
              obj.items.map((subObj, accIndex, subArr) => (
                <>
                  {subObj.key && (
                    <div
                      className={`
                                model-detail-specification-table-print__left-side-accordion-spec-title
                                model-detail-specification-table-print__left-most-cell
                                model-detail-specification-table-print__spec-row-child
                              `}
                    >
                      <div
                        className={`model-detail-specification-table-print__left-side-accordion-spec-title__inner-box 
                          ${
                            subArr.length === accIndex + 1
                              ? 'model-detail-specification-table-print__left-side-accordion-spec-title__inner-box--last-row'
                              : ''
                          }
                        `}
                      >
                        <div>{subObj.key}</div>
                      </div>
                    </div>
                  )}
                  {subObj.specs?.map((spec, specIndex) => (
                    <div
                      className={`
                        model-detail-specification-table-print__spec
                        model-detail-specification-table-print__spec--${specIndex % 2 === 0 ? 'even' : 'odd'}
                        model-detail-specification-table-print__spec-row-child
                        ${subArr.length === accIndex + 1 ? 'model-detail-specification-table-print__spec--last-row' : ''}
                      `}
                    >
                      {spec.value}
                    </div>
                  ))}
                </>
              ))}
          </>
        ))}
      </div>
    </div>
  );
}

export default PrintTable;
